import { Component, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { EventEmitter, OnInit } from "@angular/core";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { GetLinkedProjectsDto } from "../../../../core/models/task-management/getLinkedProjectsDto";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { AccordionModule } from "primeng/accordion";
import { CommonModule } from "@angular/common";
import { CardModule } from "primeng/card";
import { SpinnerComponent } from "../../spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-linked-task",
  templateUrl: "./linked-task.component.html",
  styleUrls: ["./linked-task.component.scss"],
  imports: [AccordionModule, CommonModule, CardModule, SpinnerComponent],
})
export class LinkedTaskComponent implements OnInit {
  @Output() openWorkflowSummary = new EventEmitter<{
    salesOrderId: string;
    workflowId: number;
  }>();
  //events: any;
  display = false;
  showSmallLoader = true;
  showUpcomingSmallLoader = true;
  linkedProjects: GetLinkedProjectsDto[] = [];

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit() {
    this.getLinkedProjects();
  }

  getLinkedProjects() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getLinkedProjects()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.linkedProjects = res.data || [];
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  openWorkflowSummaryModal(salesOrderId: string, workflowId: number) {
    const data = {
      salesOrderId: salesOrderId,
      workflowId: workflowId,
    };
    this.openWorkflowSummary.emit(data);
  }
}
